import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { format } from "date-fns";
import axiosConfig from "../../axiosConfig";

export interface EstimationAmountState {
  checkBox: boolean;
  estimationId: string;
  estimationItemId: string;
  estimationDateTime: string; // 日付型の estimationDateTime プロパティ
  estimationAmount: number | null; // 数値型の estimationAmount プロパティ
  estimationAmountBase: number | null; // 数値型の estimationAmountBase プロパティ
  estimationFileName: string; // 文字列型の estimationFileName プロパティ
  estimationS3FileName: string;
  urlImage?: string;
  flexSettingId: number | null;
  status: "loading" | "uploaded" | "failed" | string;
  [key: string]: any;
}
const initialState: EstimationAmountState = {
  checkBox: false,
  estimationId: "",
  estimationItemId: "",
  estimationDateTime: "",
  estimationAmount: null,
  estimationAmountBase: null,
  estimationFileName: "",
  estimationS3FileName: "",
  status: "loading",
  urlImage: "",
  flexSettingId: null,
};
export const estimationAmountAsync = createAsyncThunk(
  "estimationAmount/fetchEstimationAmount",
  async (
    {
      fileName,
      fileNameOrigin,
      extension,
      urlImage,
    }: {
      fileName: string;
      fileNameOrigin: string;
      extension: string;
      urlImage?: string;
    },
    thunkAPI
  ) => {
    // 見積AIから非同期で値を取得する
    const body = {
      fileName: fileName,
      extension: extension,
    };
    let response: any;
    try {
      response = await axiosConfig({
        method: "post",
        url: "/requests-blueprints-from-model",
        data: body,
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log("Error", error);
      return thunkAPI.rejectWithValue(error);
    }
    const json_obj = response.data.body.find((obj: any) => obj.id === "");
    const price = Number(json_obj.price);
    const payload = {
      checkBox: false,
      estimationId: "UUID", //DBのUUIDが入る
      estimationItemId: "UUIDforItem",
      estimationDateTime: format(new Date(), "yyyy-MM-dd"),
      estimationAmount: price,
      estimationAmountBase: price,
      // estimationAmount: 7000, // とりあえず7000円入れておく
      estimationFileName: fileNameOrigin,
      estimationS3FileName: fileName,
      urlImage: urlImage,
      flexSettingId: null as number | null,
      status: "uploaded",
    };
    return payload;
  }
);

export const estimationAmountSlice = createSlice({
  name: "estimationAmount",
  initialState,
  reducers: {
    // estimate: (state) => {
    //   state.value = Math.floor(Math.random() * (3000 - 2000 + 1)) + 2000;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(estimationAmountAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(estimationAmountAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.checkBox = action.payload.checkBox;
        state.estimationId = action.payload.estimationId;
        state.estimationDateTime = action.payload.estimationDateTime;
        state.estimationAmount = action.payload.estimationAmount;
        state.estimationFileName = action.payload.estimationFileName;
        state.estimationS3FileName = action.payload.estimationS3FileName;
      })
      .addCase(estimationAmountAsync.rejected, (state) => {
        state.status = "failed";
      });
  },
});

// export const { estimate } = estimationAmountSlice.actions;
export const selectEstimationAmount = (state: RootState) =>
  state.estimationAmount;
export default estimationAmountSlice.reducer;
